// ══════════════════════════════════════════════════════════════
// NPC / IFBB POSING — Elite Division-Specific Mandatory Poses
// Comprehensive coaching from IFBB Pro sources, official rules,
// and professional posing coaches
// ══════════════════════════════════════════════════════════════

const DIVISIONS = [
  {
    id: "mens_bb",
    name: "Men's Bodybuilding",
    org: "NPC / IFBB",
    desc: "Mass, symmetry, conditioning, and stage presence — the original and most demanding division",
    poses: [
      {
        id: "fdb",
        name: "Front Double Bicep",
        cues: "Feet shoulder-width, vacuum tight, spread lats wide, peak biceps hard, quads flexed and separated",
        steps: [
          "Set feet shoulder-width apart, toes turned out ~45° in a V-shape",
          "Push knees outward, flex quads for outer sweep — flex calves for stability",
          "Raise arms slightly above horizontal, elbows 10-20° forward of torso",
          "Keep shoulder blades down and out to create broader back appearance",
          "Bend elbows greater than 90° — tighten fists near ears",
          "Slightly supinate (turn up) wrists to enhance bicep peak",
          "Cock wrists down with thumb toward bicep — fills the forearm-to-bicep gap",
          "Lift sternum, pull stomach in (vacuum), spread lats as wide as possible",
          "Draw abdomen inward as if navel is touching your lower back",
        ],
        muscles: "Biceps, lats (width), quadriceps (sweep & separation), serratus, chest, calves",
        mistakes: [
          "Raising elbows above ear level — makes shoulders look narrow",
          "Forgetting to flex legs — makes physique look incomplete and top-heavy",
          "Not flaring lats — loses the V-taper illusion",
          "Shrugging shoulders toward ears — shortens neck and reduces width",
        ],
        proTips: [
          "Always flex from the ground up: feet, legs, then build upper body",
          "Imagine an invisible wire between your pinkies that must not touch your head — pulls arms back for higher peaks",
          "Practice holding 30+ seconds without shaking — judges notice instability",
        ],
      },
      {
        id: "fls",
        name: "Front Lat Spread",
        cues: "Hands on hips at iliac crest, flare lats maximally, chest high, abs vacuumed, quads tensed",
        steps: [
          "Set feet shoulder-width or slightly closer, toes out ~45° in a V",
          "Place fists on hips — thumbs at sides, pinch waist between thumb and index finger",
          "Flare elbows outward to maximize width and lat visibility (~90° angle)",
          "Squeeze shoulder blades together — imagine holding a pencil between them",
          "Drive shoulders DOWN, opposite of a shrug — feel lats engage",
          "Roll shoulders forward and slightly up — chest lifts high and proud",
          "Draw elbows forward, apply pressure into waist to spread lats maximally",
          "Draw abdomen inward (navel to spine), stand as tall as possible",
        ],
        muscles: "Lats (width), serratus, chest thickness, shoulders, quadriceps, calves",
        mistakes: [
          "Shrugging shoulders — the #1 killer of this pose",
          "Aggressively flexing everything simultaneously — makes you appear shorter and cramped",
          "Improper breathing — reduces the pose's effectiveness",
          "Losing the tall, proud posture",
        ],
        proTips: [
          "This pose is about WIDTH and POISE, not brute force flexing",
          "Phil Heath emphasizes finding YOUR specific movement pattern — every body spreads differently",
          "Practice diaphragmatic breathing to maintain chest expansion while spreading",
        ],
      },
      {
        id: "sc_l",
        name: "Side Chest (Left)",
        cues: "Clasp hands, press rear arm into chest, flex pec hard, bend front knee for sweep, calf raised",
        steps: [
          "Slightly bend the leg closest to judges, foot flat on ground",
          "Lift far leg's heel onto toes while bending at the knee",
          "Position back foot toes at mid-foot of front foot — push both legs together",
          "Bend arm nearest judges to 90°, bring across your body",
          "Grasp front wrist with other hand from behind",
          "Push front arm against body to contract chest",
          "Apply upward pressure on bent arm to maximally contract the bicep",
          "Lift ribcage high while keeping abs tight",
          "Pivot upper body slightly toward audience from the sideways position",
          "Expel air and expand rib cage for maximum chest thickness display",
        ],
        muscles: "Chest thickness, shoulder roundness, bicep/tricep density, quad/hamstring sweep, calves",
        mistakes: [
          "Not rotating torso enough toward judges — they miss your chest",
          "Forgetting to flex the back leg — loses hamstring display",
          "Dropping the ribcage — chest looks flat",
          "Not pressing arm hard enough into torso — chest doesn't pop",
        ],
        proTips: [
          "Choose your 'better' side — the side with more chest thickness or arm size",
          "Stack ribcage over hips for maximum visual impact",
          "Show both calves with a slight heel raise on the rear foot",
        ],
      },
      {
        id: "sc_r",
        name: "Side Chest (Right)",
        cues: "Mirror of left — press arm into pec, flex chest, show hamstring-quad tie-in",
        steps: [
          "Mirror all left-side instructions — right side toward judges",
          "Slightly bend right leg (closest to judges), foot flat on ground",
          "Lift left leg's heel onto toes while bending at the knee",
          "Bend right arm to 90°, bring across body, grasp with left hand from behind",
          "Push arm against body, apply upward pressure for bicep contraction",
          "Lift ribcage, pivot torso slightly toward audience, expand rib cage",
        ],
        muscles: "Chest thickness, shoulder roundness, bicep/tricep density, quad/hamstring sweep, calves",
        mistakes: [
          "Weaker execution than your preferred side — practice both equally",
          "Rushing through because it's your 'off' side",
        ],
        proTips: [
          "Many competitors neglect their weak side — judges notice the asymmetry in execution",
        ],
      },
      {
        id: "bdb",
        name: "Back Double Bicep",
        cues: "Foot back on toe for calf, spread lats wide, peak biceps, flex glutes and hamstrings hard",
        steps: [
          "Turn to face away from judges",
          "Step one foot back and flex that calf — choose your stronger side unless judges specify",
          "Set legs and glutes FIRST before touching arms",
          "Squeeze glutes as hard as possible — judges look for conditioning and striations",
          "Flex hamstrings to show sweep and separation",
          "Raise arms into double biceps position (same as front but facing away)",
          "Flex biceps while squeezing shoulder blades to display back thickness",
          "Supinate wrists slightly for bicep peak, keep elbows slightly forward",
        ],
        muscles: "Back width (lats), back thickness (rhomboids, mid-traps), rear delts, biceps, glutes, hamstrings, calves",
        mistakes: [
          "Setting arms before legs — judges see soft glutes and hamstrings first",
          "Relaxing glutes or hamstrings — instantly noticeable",
          "Forgetting calves — they look soft and undeveloped",
          "Over-arching the lower back — distorts the pose",
        ],
        proTips: [
          "One of the hardest poses because you can't see yourself — use back mirrors or video extensively",
          "The glute-hamstring tie-in is one of the most scrutinized areas",
          "Bend knees slightly to help activate hamstrings",
        ],
      },
      {
        id: "bls",
        name: "Back Lat Spread",
        cues: "Hands on hips, spread lats wide, flex glutes, show rear delt separation and Christmas tree",
        steps: [
          "Stand with back to judges, one foot back on ball of foot to flex calf",
          "Place hands on sides slightly above hips — thumbs on hips, fingers wrapping forward",
          "Pull elbows forward to stretch shoulder blades apart",
          "Continue pulling elbows forward until lats spread as far as possible",
          "Slightly round your upper back — creates the 'cobra-hood' look",
          "Lean back slightly toward judges to reveal size and depth in lats, rear delts, traps",
          "Hold peak contraction while rounding chest for additional definition and width",
          "Squeeze glutes maximally — striations should be visible",
        ],
        muscles: "Lat width (primary), trapezius thickness, rear delts, glutes, hamstrings, calves",
        mistakes: [
          "Hunching forward too aggressively — ruins chest lift",
          "Relaxed glutes or hamstrings — instantly obvious from the judges' table",
          "Forgetting calves — makes them look soft",
          "Losing waist control — ruins taper and makes back look less wide",
        ],
        proTips: [
          "The 'cobra-hood' effect is achieved by a slight forward round — practice finding the sweet spot",
          "A 30-minute posing session on back poses can be as exhausting as a high-volume back workout",
          "Keep hamstrings tight to show sweep and separation",
        ],
      },
      {
        id: "st_l",
        name: "Side Tricep (Left)",
        cues: "Clasp behind back, lock arm for tricep, twist torso for abs, flex quads",
        steps: [
          "Plant toes on floor with feet a few inches apart",
          "Keep back leg straightened, flex front leg while lifting front heel",
          "Center feet and toes together, overlap knees, sink down to form the hamstring drop",
          "Place both arms behind your back",
          "Use back arm to grip wrist of front arm at small of your back (or link fingers)",
          "Front upper arm pressed against your side",
          "Exhale while tightening abs, legs, deltoids, and triceps",
          "Press front arm outward against the grip to maximally contract the tricep",
          "Rotate body to show lateral tricep from judges' angle",
        ],
        muscles: "Triceps (lateral & long heads), shoulder/chest from side, calves, thigh separation, forearms",
        mistakes: [
          "Not pressing hard enough against grip — tricep doesn't fully contract",
          "Forgetting to flex legs — top-heavy appearance",
          "Not sinking into pose enough — loses hamstring display",
          "Slouching forward",
        ],
        proTips: [
          "Dorian Yates is the gold standard for this pose",
          "Slightly touch fingers behind back for maximum control",
          "Rotate enough that judges see the full horseshoe shape of the tricep",
        ],
      },
      {
        id: "st_r",
        name: "Side Tricep (Right)",
        cues: "Mirror of left — lock arm for horseshoe tricep, tight waist, quad sweep",
        steps: [
          "Mirror all left-side instructions with right side toward judges",
          "Grip right wrist with left hand behind back",
          "Press right arm outward to contract tricep, rotate body toward judges",
          "Exhale, tighten everything — abs, legs, deltoids, triceps",
        ],
        muscles: "Triceps (lateral & long heads), shoulder/chest from side, calves, thigh separation, forearms",
        mistakes: [
          "Weaker grip or contraction on non-dominant side",
        ],
        proTips: [
          "Judges may request either side — practice both until equally polished",
        ],
      },
      {
        id: "at",
        name: "Abs & Thigh",
        cues: "Hands behind head, crunch abs hard, exhale and vacuum, one leg forward with quad fully flexed",
        steps: [
          "Stand facing judges, feet together or staggered (best leg forward)",
          "Bring one leg forward, lock at knee, point the toe — required to flex the calf",
          "Turn lead leg outward slightly to reveal inner calf, sartorius, upper-quad separation",
          "Inhale deeply, place both hands behind neck with fingers interlocked",
          "Lift head up, force shoulders DOWN, flex lats wide",
          "Exhale ALL air from lungs",
          "Crunch down on abs hard — but don't lean so far that skin folds loosely over muscle",
          "Keep lats flared to maintain V-taper throughout the crunch",
          "After one side, switch legs and repeat",
        ],
        muscles: "Abdominals (rectus, obliques), quadriceps (separation), serratus, lat width (V-taper), calves",
        mistakes: [
          "Over-flexing quads so hard they lose definition",
          "Poor hand positioning that makes waist appear wider",
          "Slouching or leaning too far forward",
          "Forgetting to maintain lat flare",
        ],
        proTips: [
          "This is THE conditioning pose — if body fat isn't low enough, this pose will expose it",
          "Classic Physique competitors often open with a vacuum before the crunch",
          "Switch legs smoothly — judges notice awkward transitions",
        ],
      },
      {
        id: "mm",
        name: "Most Muscular",
        cues: "Crab or hands-on-hips variation — flex everything, show trap and delt fullness",
        steps: [
          "VARIANT A (Crab): Feet shoulder-width, one leg forward, knees out",
          "Hinge forward slightly, ball fists with a few inches between them",
          "Shrug shoulders up toward ears, contract traps, shoulders, chest, arms maximally",
          "Lean forward to emphasize traps/delts; further if shoulders are a strength",
          "VARIANT B (Hands-on-Hips / Frank Zane): Feet shoulder-width, back straight",
          "Place hands on hips, thumbs back, fingers forward, elbows naturally out",
          "Contract chest and shoulders forward and upward, keep head up, chin parallel",
          "Slightly arch lower back — more aesthetic, shows chest striations and abs",
        ],
        muscles: "All front-facing: pecs, obliques, anterior delts, biceps, forearms, abs, quads, calves",
        mistakes: [
          "Crunching forward too far — looks smaller and cramped",
          "Forgetting legs — top-heavy and flat quads",
          "Loose midsection destroys the illusion of power",
        ],
        proTips: [
          "Choose the variant that suits YOUR physique — massive traps favor crab, great conditioning favors Zane",
          "Harold Poole popularized this pose — it showcases MAXIMUM muscle simultaneously",
          "If you lack the mass for the crab, the Zane version is more strategic",
        ],
      },
    ],
  },
  {
    id: "classic",
    name: "Classic Physique",
    org: "NPC / IFBB",
    desc: "Golden-era aesthetics with size limits by height — vacuum control and flowing transitions",
    poses: [
      {
        id: "fdb",
        name: "Front Double Bicep",
        cues: "Same as BB but greater emphasis on V-taper and waist control — distended midsections penalized",
        steps: [
          "Set feet shoulder-width, toes out ~45° — stagger if it enhances your taper",
          "Push knees outward, flex quads for sweep, flex calves",
          "Raise arms slightly above horizontal, elbows 10-20° forward",
          "Keep shoulder blades down and out for maximum width",
          "Bend elbows >90°, fists near ears, supinate wrists for bicep peak",
          "CRITICAL: Draw abdomen completely in — vacuum tight — judges penalize any bloat",
          "Spread lats wide to create the widest possible V-taper",
        ],
        muscles: "Biceps, lats (V-taper), quadriceps, serratus, chest, calves",
        mistakes: [
          "Any midsection distension — Classic judges penalize this more harshly than Open",
          "Losing the proportional aesthetic for sheer mass display",
          "Not maintaining the small-waist illusion throughout",
        ],
        proTips: [
          "Classic Physique is judged on PROPORTION, not just size",
          "Chris Bumstead: 'Posing helps build a stronger mind-muscle connection by teaching your body to contract with precision'",
          "Practice the vacuum daily on an empty stomach — it separates champions from contenders",
        ],
      },
      {
        id: "sc",
        name: "Side Chest",
        cues: "Clasp hands, flex pec and bicep, bend front knee for sweep, chest high, waist tight",
        steps: [
          "Slightly bend leg closest to judges, foot flat",
          "Lift far leg's heel onto toes, bend at knee",
          "Position back foot toes at mid-foot of front foot, push legs together",
          "Bend nearest arm to 90°, bring across body, grasp with other hand",
          "Push arm against body for chest contraction, apply upward pressure for bicep",
          "Lift ribcage HIGH while keeping abs vacuum-tight",
          "Pivot upper body toward audience, expel air, expand rib cage",
        ],
        muscles: "Chest thickness, shoulder roundness, arm size, quad/hamstring sweep, calves",
        mistakes: [
          "Losing the old-school aesthetic — this division rewards flowing lines and chest fullness",
          "Not keeping waist tight enough — ruins the classic look",
        ],
        proTips: [
          "Classic Physique rewards the old-school look — think Arnold, Zane, Labrada",
          "Stack ribcage over hips for maximum visual impact",
        ],
      },
      {
        id: "bdb",
        name: "Back Double Bicep",
        cues: "Foot back on toe, spread lats, flex biceps, show glute-ham tie-in and rear detail",
        steps: [
          "Turn away from judges, step one foot back, flex that calf",
          "Set legs and glutes FIRST — squeeze glutes hard for conditioning",
          "Flex hamstrings for sweep and separation",
          "Raise arms into double biceps position",
          "Flex biceps while squeezing shoulder blades for back thickness",
          "Emphasis on back width PROPORTIONAL to waist — not just sheer mass",
        ],
        muscles: "Back width (lats), thickness, rear delts, biceps, glutes, hamstrings, calves",
        mistakes: [
          "Displaying too much mass without proportion — Classic favors V-taper over width alone",
          "Setting arms before legs — judges see soft glutes first",
        ],
        proTips: [
          "Focus on width-to-waist ratio rather than raw back mass",
          "The glute-hamstring tie-in remains heavily scrutinized",
        ],
      },
      {
        id: "at",
        name: "Abs & Thigh",
        cues: "Two-part pose: vacuum FIRST, then crunch — one leg forward with quad fully flexed, show serratus",
        steps: [
          "PART 1 — VACUUM: Deeply exhale, draw abdomen inward (navel to spine)",
          "Flex transverse inner muscle while flexing legs, torso, and arms simultaneously",
          "Hold the vacuum for a clear beat — let judges see it",
          "PART 2 — CRUNCH: Contract abs by crunching trunk slightly forward",
          "Move one leg forward, contract thigh muscles fully",
          "Hands behind head, fingers interlocked, shoulders DOWN, lats wide",
          "Exhale all air, crunch hard but don't fold too far forward",
          "Switch legs and repeat",
        ],
        muscles: "Abdominals, obliques, quadriceps (separation), serratus, lat width, calves",
        mistakes: [
          "Skipping the vacuum — it's a two-part pose in Classic, unlike Open BB",
          "Leaning too far forward in the crunch",
        ],
        proTips: [
          "The vacuum portion is what separates Classic from Open — master it",
          "Practice vacuum progression: lying → seated → all-fours → standing",
          "Daily morning practice on an empty stomach accelerates mastery",
        ],
      },
      {
        id: "fav",
        name: "Favorite Classic Pose",
        cues: "Your chance to showcase your best angle — sell the aesthetic, evoke the Golden Era",
        steps: [
          "Choose a pose that highlights YOUR best features — vacuum, side chest, archer, etc.",
          "Must evoke Golden Era aesthetic — think Arnold's side chest, Zane's vacuum, Labrada's transitions",
          "Enter the pose with confidence and showmanship",
          "Hold with unwavering composure — sell it to the judges",
          "Flow into and out of the pose smoothly — transitions are part of the presentation",
        ],
        muscles: "Athlete's choice — whatever your strongest bodypart demands",
        mistakes: [
          "Choosing a pose that exposes your weakness",
          "Not practicing transitions into/out of it",
          "Lacking conviction — half-committed looks worse than a simpler pose done well",
        ],
        proTips: [
          "This is where stage presence and artistry separate champions from contenders",
          "Lee Labrada: 'The mesmerizing presentation comes from the transitions — don't fumble from one static pose to the next'",
          "Insert your most impactful pose at the high points of the music",
        ],
      },
    ],
  },
  {
    id: "mens_phys",
    name: "Men's Physique",
    org: "NPC / IFBB",
    desc: "Athletic V-taper, board shorts, relaxed confidence — extreme muscularity is marked DOWN",
    poses: [
      {
        id: "front",
        name: "Front Stance",
        cues: "Left hand on hip, right arm relaxed, slight torso twist, shoulder-to-waist ratio, DO NOT hard flex",
        steps: [
          "One foot slightly forward, weight distributed with slightly more on back leg",
          "Create a small torso twist to enhance the V-taper",
          "Left hand rests on left hip (per IFBB rules)",
          "Right arm held down and slightly to the front from centerline",
          "Right elbow slightly bent, open palm, straight aesthetically configured fingers",
          "Left leg (nearest judges) slightly bent at knee, foot flat",
          "Project wide shoulder-to-narrow-waist ratio — DO NOT flex abs hard",
          "Maintain an athletic, relaxed look — not a bodybuilder look",
        ],
        muscles: "V-taper, shoulder width, overall athletic proportions",
        mistakes: [
          "Over-flexing or looking too 'bodybuilder' — judges mark this DOWN",
          "Stiff, robotic positioning — this division rewards smooth, relaxed confidence",
          "Forgetting facial expression — smile and project confidence",
          "Poor posture — shoulders must be back, chest up",
        ],
        proTips: [
          "This division is about the TOTAL aesthetic package — not size",
          "Think 'beach model with muscle' rather than 'bodybuilder on vacation'",
        ],
      },
      {
        id: "back",
        name: "Back Stance",
        cues: "Show V-taper and rear delt caps, lats subtly spread, confident posture, NO aggressive flexing",
        steps: [
          "Similar foot positioning to front pose but facing away",
          "Display shoulder width, back taper, and overall posterior conditioning",
          "Arms relaxed at sides or one hand on hip (check federation rules)",
          "Show lat width WITHOUT aggressive flexing — subtle engagement",
          "Confident, relaxed posture throughout",
        ],
        muscles: "Back taper (V-shape), rear delts, overall posterior conditioning",
        mistakes: [
          "Aggressively flexing lats or traps — this isn't bodybuilding",
          "Tense, forced posture — must look natural and confident",
        ],
        proTips: [
          "Lat engagement should be barely visible — just enough to show the taper",
        ],
      },
      {
        id: "qt_l",
        name: "Left Quarter Turn",
        cues: "Smooth 90° rotation, show shoulder-to-waist ratio, chest high, relaxed confidence",
        steps: [
          "Execute a smooth 90° rotation to show left side profile",
          "Show side delts, arm shape, chest-to-waist ratio",
          "Maintain the relaxed, athletic look throughout the turn",
          "Transitions must be smooth and confident — judges assess grace and elegance",
        ],
        muscles: "Side delts, arm shape, chest-to-waist ratio, overall flow",
        mistakes: [
          "Jerky, rushed transitions — judges assess pace and showmanship",
          "Losing the relaxed expression during the turn",
        ],
        proTips: [
          "Judges assess grace, pace, elegance, gestures, showmanship, personality, and charisma",
          "Practice smooth transitions in board shorts to get the full effect",
        ],
      },
      {
        id: "qt_r",
        name: "Right Quarter Turn",
        cues: "Mirror of left — show taper, arm hanging natural, subtle lat engagement",
        steps: [
          "Execute a smooth 90° rotation to show right side profile",
          "Mirror the left quarter turn positioning and engagement",
          "Maintain consistent expression and posture quality on both sides",
        ],
        muscles: "Side delts, arm shape, chest-to-waist ratio, overall flow",
        mistakes: [
          "Noticeably weaker presentation on one side — practice both equally",
        ],
        proTips: [
          "Film yourself from both sides — you'd be surprised how different they can look",
        ],
      },
    ],
  },
  {
    id: "bikini",
    name: "Bikini",
    org: "NPC / IFBB",
    desc: "Balanced, toned physique with stage presence, confidence, and personality — the walk is a majority of the score",
    poses: [
      {
        id: "front",
        name: "Front Pose",
        cues: "Hand on hip, shift weight to back leg, push hips to one side, twist waist, arch lower back",
        steps: [
          "Set feet shoulder-width apart, toes forward",
          "One leg slightly in front, weight shifted to back leg",
          "Push hips to one side and twist waist toward side stage",
          "Maintain shoulders in a forward position",
          "Arch lower back slightly, lift chest",
          "Angle shoulders to create hourglass shape",
          "One hand on hip, other arm relaxed or on opposite hip",
        ],
        muscles: "Overall balance, feminine curves, midline taper, abs, glute separation",
        mistakes: [
          "Over-arching the lower back (slight arch good, excessive is not)",
          "Looking at the floor — always maintain eye contact and confidence",
          "Loose abs during transitions",
          "Hitting too many poses — 'the more poses you hit, the more chances for judges to find flaws' (NPC judge)",
        ],
        proTips: [
          "Judges look at EVERYTHING — toe point, glute separation, midline taper, abs, curves",
          "Practice in competition heels extensively — it changes everything",
        ],
      },
      {
        id: "back",
        name: "Back Pose",
        cues: "Tilt hips forward and to one side, flat back, both shoulders down, show glute/hamstring shape",
        steps: [
          "Set feet shoulder-width apart, toes forward",
          "Tilt hips forward and to one side so glutes show — 'think about your booty touching your back'",
          "Both shoulders down and equally forward",
          "Weight off to one side, one hand on hip",
          "Practice having a flat back — no chicken wings (elbows flaring out)",
          "Showcase glute/hamstring separation without excessively sticking out the butt",
        ],
        muscles: "Glutes, hamstrings, back shape, shoulder symmetry",
        mistakes: [
          "Chicken wings — elbows flaring out to the sides",
          "Excessively sticking out the butt — judges want to see shape, not a caricature",
          "Not turning enough to show glute development",
        ],
        proTips: [
          "'Competitions can be won the moment you turn around' — the back pose is THAT important",
          "Practice the back pose more than any other — it's where shows are won and lost",
        ],
      },
      {
        id: "t_walk",
        name: "T-Walk",
        cues: "Turn 180°, adopt back pose, walk SLOW to the beat, keep glutes tight, no shaking",
        steps: [
          "From front pose, turn 180° toward rear of stage, adopt back pose",
          "Walk options: toe-over-toe (tightrope style) OR shoulder-width stride — whichever looks natural",
          "Walk SLOW — listen to the music beat",
          "The second-slowest beat in the song is your stride pace",
          "Keep glutes turned up and tight — avoid any shaking",
          "Stride length should match your leg length and mobility range",
          "Maintain personality and confidence throughout",
        ],
        muscles: "Glutes (activation throughout), hamstrings, overall stage presence",
        mistakes: [
          "Walking too fast — this is the most common mistake",
          "Shaking or loose glutes during the walk",
          "Stride length that doesn't match your body — looks unnatural",
          "Not practicing in competition heels enough",
        ],
        proTips: [
          "'A majority of your score is based off this walk' — practice extensively in competition heels",
          "Film yourself walking and compare stride pace to music beats",
        ],
      },
      {
        id: "model",
        name: "Model Quarter Turns",
        cues: "Smooth controlled rotations, use transitions to showcase glutes and personality",
        steps: [
          "Execute smooth, controlled 90° rotations between poses",
          "Use transitions to showcase glutes, triceps, and personality",
          "Good opportunity for a subtle wink or confident smile",
          "Maintain composure and stage presence throughout",
        ],
        muscles: "Overall physique, glutes, triceps from rotation angles",
        mistakes: [
          "Rushed or jerky transitions — must be smooth and deliberate",
          "Losing the smile or looking uncomfortable during rotations",
        ],
        proTips: [
          "Quarter turns are a chance to show personality — don't waste them being robotic",
          "Practice transitions as much as the poses themselves",
        ],
      },
    ],
  },
  {
    id: "figure",
    name: "Figure",
    org: "NPC / IFBB",
    desc: "Muscular but feminine, athletic symmetry and conditioning — V-taper with open lats",
    poses: [
      {
        id: "front",
        name: "Front Pose",
        cues: "Feet together, one slightly forward, lats open/flared, quads flexed, deep breath for chest lift",
        steps: [
          "Set feet together or one just slightly in front — heels no wider than 2-3 inches",
          "Hips face judges, lats open/flared to show V-taper",
          "Flex quads to display leg muscle development",
          "Take a deep breath to raise chest and shoulders",
          "Arms slightly out from sides in a rounded position (as if holding a beach ball)",
          "Keep arms tight and firm",
          "Head and chin held high with a smile",
        ],
        muscles: "V-taper, quad development, shoulder width, overall symmetry",
        mistakes: [
          "Not flaring lats for V-taper — this is essential in Figure",
          "Neglecting quad flex — judges assess the complete package top to bottom",
          "Hands placed on body (not allowed in Figure)",
        ],
        proTips: [
          "The 'beach ball' arm position creates a wider, more commanding silhouette",
          "Practice the deep breath technique — it dramatically improves chest and shoulder presentation",
        ],
      },
      {
        id: "back",
        name: "Back Pose",
        cues: "Hair up, lats open for V-taper, arms at sides slightly rounded, back development visible",
        steps: [
          "Feet together or very close — heels within 2-3 inches, one foot slightly offset",
          "Brush hair to one side so back is visible (hair MUST be worn up during judging)",
          "Arms at sides, slightly rounded and tight",
          "Lats open to display V-taper, back development, conditioning",
          "Do NOT place hands on body",
        ],
        muscles: "Back V-taper, glute-hamstring tie-in, calf development, conditioning",
        mistakes: [
          "Placing hands on body — not allowed",
          "Hair covering the back — must be worn up",
          "Neglecting to flare lats for V-taper display",
        ],
        proTips: [
          "Practice with hair up to ensure your back presentation is polished",
          "The V-taper from behind is a key differentiator in Figure",
        ],
      },
      {
        id: "qt_l",
        name: "Left Side Pose",
        cues: "Both feet flat, upper body turned toward judges, hips face side, hands must NOT be on body",
        steps: [
          "Both feet flat, toes facing side of stage",
          "Feet offset only half the distance of the foot",
          "Upper body turned toward judges so rear shoulder is visible (not too exaggerated)",
          "Hips MUST face the side of the stage",
          "Eyes face side of stage",
          "Push long hair behind front shoulder",
          "Front and rear hands must NOT be placed on body — hang freely with palms toward body",
          "Optional: drop front shoulder back slightly while pulling back shoulder forward for wider appearance",
        ],
        muscles: "Shoulder caps, quad sweep, waist tightness, arm shape",
        mistakes: [
          "Twisting upper body completely toward judges (not allowed — only a turn, not a full rotation)",
          "Placing hands on body during side poses",
          "Hair blocking the view of shoulders or back",
        ],
        proTips: [
          "The slight upper body turn is an art — practice finding the exact angle that shows width with a narrow waist",
        ],
      },
      {
        id: "qt_r",
        name: "Right Side Pose",
        cues: "Mirror of left — show muscle maturity and symmetry from all angles",
        steps: [
          "Mirror all left-side instructions for the right side",
          "Maintain the same quality of presentation on both sides",
          "Both feet flat, toes toward side of stage, slight upper body turn toward judges",
          "Hands hanging freely, palms toward body",
        ],
        muscles: "Shoulder caps, quad sweep, waist tightness, arm shape",
        mistakes: [
          "Inconsistent presentation between left and right sides",
        ],
        proTips: [
          "Judges assess the COMPLETE package from top to bottom — every angle matters equally",
        ],
      },
    ],
  },
  {
    id: "wellness",
    name: "Wellness",
    org: "NPC / IFBB",
    desc: "Full, round glutes with lower body emphasis — upper body developed but not dominant",
    poses: [
      {
        id: "front",
        name: "Front Pose",
        cues: "Legs in T-fashion, front leg flexed, knees turned OUT for max width, do NOT flare lats",
        steps: [
          "Set legs in a T-fashion — front foot facing forward, other leg pointed out to the side",
          "Front leg flexed and slightly forward (key difference from Bikini)",
          "Squeeze glutes while maintaining upright posture",
          "One arm extended to the side, other on ribs or slightly lower to emphasize taper",
          "Turn knees OUT to maximize width and thickness of legs, hips, and glutes",
          "Do NOT stand completely front-on (shows widest part of waistline)",
          "Do NOT flare lats — goal is smaller upper body appearance",
        ],
        muscles: "Glutes, hips, thighs (primary emphasis), overall balance",
        mistakes: [
          "Flaring lats — you want to appear SMALLER on top, not wider",
          "Standing completely front-on — exposes widest waistline angle",
          "'Teapot position' (arm to side with bent elbow and bent wrist) — officially marked down by NPC",
          "Over-developing upper body display — this division highlights the lower half",
        ],
        proTips: [
          "Wellness is about LOWER BODY — your upper body supports, not dominates",
          "The T-foot stance creates maximum visual impact for leg and glute development",
        ],
      },
      {
        id: "back",
        name: "Back Pose",
        cues: "Arch lower back, push glutes toward front of stage, soft knees for activation, round and full",
        steps: [
          "Set feet slightly wider than hip-width, toes pointed out slightly",
          "Arch lower back, push glutes toward front of stage",
          "Do NOT lean forward too much",
          "Keep knees soft — push down to activate legs for glute/hamstring tightness",
          "Rotate hips and pelvis back so glutes appear round and full",
          "Judges do NOT want to see lines underneath glutes",
        ],
        muscles: "Glutes (round, full), hamstrings, overall lower body conditioning",
        mistakes: [
          "Leaning forward too much — subtle arch only",
          "Showing lines underneath glutes — judges specifically don't want this",
          "Locked knees — soft knees activate the glute-ham tie-in better",
        ],
        proTips: [
          "When walking to the rear, judges look for glute tightness and activation rather than walk style",
          "Full, round glutes with slight glute-hamstring separation but NO striations — that's the target",
        ],
      },
      {
        id: "qt_l",
        name: "Left Side Pose",
        cues: "Create thickness through front leg, push into hip, soft knee, keep bellybutton to the side",
        steps: [
          "Create thickness through front leg by pushing into hip and softening knee",
          "Activate quad and hamstring in the pose",
          "Keep waistline small by keeping bellybutton facing toward side of room",
          "Avoid overbending knees",
        ],
        muscles: "Quad/hamstring thickness, glute fullness from side, waistline control",
        mistakes: [
          "Overbending knees — looks unnatural and breaks the line",
          "Turning bellybutton toward judges — makes waist look wider",
        ],
        proTips: [
          "The push into the hip creates visual thickness in the leg — practice finding the angle that maximizes it",
        ],
      },
      {
        id: "qt_r",
        name: "Right Side Pose",
        cues: "Mirror of left — show the signature wellness lower body thickness from all angles",
        steps: [
          "Mirror all left-side instructions for the right side",
          "Maintain the same thickness and activation on both sides",
          "Keep waistline small, bellybutton toward side of room",
        ],
        muscles: "Quad/hamstring thickness, glute fullness from side, waistline control",
        mistakes: [
          "Inconsistent thickness display between sides",
        ],
        proTips: [
          "Film both sides and compare — your 'weak' side needs extra practice",
        ],
      },
    ],
  },
  {
    id: "womens_phys",
    name: "Women's Physique",
    org: "NPC / IFBB",
    desc: "Muscular and defined with femininity and symmetry — open hands, no heels, hair up",
    poses: [
      {
        id: "fdb",
        name: "Front Double Bicep",
        cues: "OPEN HANDS (not fists), one leg in front for body curvature, vacuum tight, V-taper and separation",
        steps: [
          "Place one leg in front to accentuate body curvature (key difference from Men's)",
          "Raise arms — elbows level with each other or slightly above horizontal, NEVER below",
          "Hands must remain OPEN (not clenched fists) — this is a Women's Physique requirement",
          "Flex biceps with lats flared wide",
          "Vacuum tight, show V-taper and quad separation",
        ],
        muscles: "Biceps, lats, V-taper, quads, overall conditioning",
        mistakes: [
          "Clenching fists — hands MUST be open in Women's Physique",
          "Elbows dropping below horizontal — diminishes the pose",
          "Standing flat-footed with no front twist — some sort of front twisting pose is expected",
        ],
        proTips: [
          "Hair must be worn UP, off shoulders and back during judging",
          "No heels at any time in Women's Physique",
          "The open hand gives a more feminine, graceful look",
        ],
      },
      {
        id: "sc",
        name: "Side Chest",
        cues: "Performed with BOTH arms extended (different from traditional clasp), chest high, one knee bent",
        steps: [
          "Key difference: performed with BOTH arms extended (not traditional clasp)",
          "One knee bent to show leg sweep",
          "Chest lifted high, waist tight",
          "Show chest thickness and shoulder roundness from the side",
          "Maintain feminine presentation with muscular display",
        ],
        muscles: "Chest thickness, shoulder roundness, arm size, quad/hamstring sweep",
        mistakes: [
          "Using the traditional clasp (Men's BB style) — Women's Physique uses both arms extended",
          "Losing femininity in pursuit of maximum muscle display",
        ],
        proTips: [
          "The extended arm variation is unique to Women's Physique — practice it specifically",
        ],
      },
      {
        id: "bdb",
        name: "Back Double Bicep",
        cues: "OPEN HANDS, lats spread, flex biceps, show glute conditioning and hamstring development",
        steps: [
          "Turn away from judges, step one foot back for calf display",
          "Hands must remain OPEN (not fists)",
          "Flex biceps with lats spread",
          "Show glute conditioning and hamstring development",
          "Emphasis on back width, glute conditioning, and hamstring development",
        ],
        muscles: "Back width, glute conditioning, hamstrings, biceps, calves",
        mistakes: [
          "Clenching fists — OPEN HANDS required",
          "Soft glutes — conditioning is critical in this division",
        ],
        proTips: [
          "Practice this pose extensively with back mirrors — you can't see yourself",
          "Glute conditioning separates top placers from the pack",
        ],
      },
      {
        id: "st",
        name: "Side Tricep",
        cues: "One leg extended (division-specific variation), clasp behind back, show horseshoe tricep",
        steps: [
          "Key difference: performed with one leg extended",
          "Clasp hands behind back at small of back",
          "Press arm outward against grip for maximum tricep contraction",
          "Twist torso to show abs and overall conditioning",
          "Flex extended leg to show quad sweep",
        ],
        muscles: "Triceps, shoulder/chest from side, quad sweep, overall conditioning",
        mistakes: [
          "Not extending the leg — misses the division-specific element",
          "Weak grip and contraction — tricep must be fully flexed",
        ],
        proTips: [
          "Practice on BOTH sides — judges may request either",
          "The extended leg adds complexity — rehearse the balance",
        ],
      },
      {
        id: "at",
        name: "Abs & Thigh",
        cues: "Hands behind head, crunch hard, one leg forward with quad flexed, show serratus and obliques",
        steps: [
          "Hands behind head, fingers interlocked",
          "Lift head, force shoulders down, flex lats wide",
          "Exhale all air, crunch abs hard",
          "One leg forward with quad fully flexed, toe pointed",
          "Show serratus and obliques — full midsection control is critical",
          "Switch legs and repeat",
        ],
        muscles: "Abdominals, obliques, serratus, quadriceps, calves",
        mistakes: [
          "Leaning too far forward in the crunch",
          "Not showing serratus — it's a key differentiator",
        ],
        proTips: [
          "Full midsection control and quad separation are critical in this division",
          "This pose reveals conditioning truth — it can't be faked",
        ],
      },
    ],
  },
  {
    id: "womens_bb",
    name: "Women's Bodybuilding",
    org: "NPC / IFBB",
    desc: "Maximum muscularity, symmetry, and conditioning — same pose set as Men's Open",
    poses: [
      {
        id: "fdb",
        name: "Front Double Bicep",
        cues: "Spread lats, peak biceps, vacuum, show full quad separation and sweep",
        steps: [
          "Same technique as Men's Bodybuilding front double bicep",
          "Set feet shoulder-width, toes out ~45°",
          "Raise arms above horizontal, bend elbows >90°, peak biceps",
          "Supinate wrists for bicep peak, vacuum tight, lats spread wide",
          "Flex quads for maximum separation and sweep",
        ],
        muscles: "Biceps, lats (width), quadriceps, serratus, chest, calves",
        mistakes: [
          "Same pitfalls as Men's BB — elbows too high, forgetting legs, not flaring lats",
        ],
        proTips: [
          "Women's BB is judged on the same criteria of muscularity, symmetry, and conditioning as Men's",
        ],
      },
      {
        id: "fls",
        name: "Front Lat Spread",
        cues: "Hands on hips, flare lats maximally, chest high, abs tight, quads flexed",
        steps: [
          "Same technique as Men's Bodybuilding front lat spread",
          "Fists on hips, flare elbows, squeeze then drive shoulders down, roll forward",
          "Spread lats maximally, chest high and proud, abs vacuumed",
          "Quads fully tensed throughout",
        ],
        muscles: "Lats, serratus, chest thickness, shoulders, quads, calves",
        mistakes: [
          "Shrugging shoulders — always the #1 killer of any lat spread",
        ],
        proTips: [
          "Find YOUR specific spread pattern — every body spreads differently",
        ],
      },
      {
        id: "sc_l",
        name: "Side Chest (Left)",
        cues: "Clasp hands, press arm into pec, flex chest hard, bend knee for quad sweep",
        steps: [
          "Same technique as Men's Bodybuilding side chest",
          "Bend nearest arm to 90°, grasp wrist, push arm into chest",
          "Lift ribcage, pivot toward audience, expand rib cage",
          "Show chest thickness, leg sweep, and calf development",
        ],
        muscles: "Chest thickness, shoulder roundness, bicep/tricep, quad/hamstring sweep, calves",
        mistakes: [
          "Not pressing arm firmly enough — chest must pop",
          "Dropping the ribcage — chest looks flat",
        ],
        proTips: [
          "Choose your better side based on chest thickness and arm size",
        ],
      },
      {
        id: "sc_r",
        name: "Side Chest (Right)",
        cues: "Mirror of left side — show chest thickness and leg development",
        steps: [
          "Mirror all left-side instructions for the right side",
          "Maintain equal quality of execution on both sides",
        ],
        muscles: "Chest thickness, shoulder roundness, bicep/tricep, quad/hamstring sweep, calves",
        mistakes: [
          "Weaker execution on non-dominant side",
        ],
        proTips: [
          "Practice both sides equally — judges notice asymmetric execution",
        ],
      },
      {
        id: "bdb",
        name: "Back Double Bicep",
        cues: "Foot back on toe, lats wide, biceps peaked, flex glutes and hamstrings",
        steps: [
          "Same technique as Men's Bodybuilding back double bicep",
          "Set legs and glutes FIRST — squeeze glutes hard",
          "Flex hamstrings, raise arms, peak biceps, squeeze shoulder blades",
          "Show conditioning through the entire posterior chain",
        ],
        muscles: "Back width, thickness, rear delts, biceps, glutes, hamstrings, calves",
        mistakes: [
          "Setting arms before legs — posterior conditioning is judged first",
        ],
        proTips: [
          "Glute-hamstring tie-in is heavily scrutinized — never neglect it",
        ],
      },
      {
        id: "bls",
        name: "Back Lat Spread",
        cues: "Hands on hips, lats flared, show Christmas tree and rear delt separation",
        steps: [
          "Same technique as Men's Bodybuilding back lat spread",
          "Hands on hips, pull elbows forward, spread lats maximally",
          "Slight forward round for cobra-hood effect",
          "Squeeze glutes — striations should be visible",
        ],
        muscles: "Lat width, traps, rear delts, glutes, hamstrings, calves",
        mistakes: [
          "Hunching too aggressively — find the sweet spot",
          "Relaxing glutes during back poses",
        ],
        proTips: [
          "The Christmas tree (lower back detail) is a sign of elite conditioning",
        ],
      },
      {
        id: "st_l",
        name: "Side Tricep (Left)",
        cues: "Clasp behind back, lock tricep, show abs and quad detail",
        steps: [
          "Same technique as Men's Bodybuilding side tricep",
          "Grip wrist behind back, press outward for tricep contraction",
          "Exhale, tighten abs, legs, deltoids, and triceps",
          "Show horseshoe tricep shape",
        ],
        muscles: "Triceps, shoulder/chest, calves, thigh separation, forearms",
        mistakes: [
          "Insufficient contraction — really press against the grip",
        ],
        proTips: [
          "Dorian Yates is the gold standard reference for this pose",
        ],
      },
      {
        id: "st_r",
        name: "Side Tricep (Right)",
        cues: "Mirror of left — horseshoe tricep, tight waist, quad sweep",
        steps: [
          "Mirror all left-side instructions for the right side",
          "Maintain equal contraction and presentation quality",
        ],
        muscles: "Triceps, shoulder/chest, calves, thigh separation, forearms",
        mistakes: [
          "Inconsistent execution between sides",
        ],
        proTips: [
          "Both sides must be equally polished for callouts",
        ],
      },
      {
        id: "at",
        name: "Abs & Thigh",
        cues: "Hands behind head, crunch, one leg forward fully flexed, show serratus",
        steps: [
          "Same technique as Men's Bodybuilding abs & thigh",
          "Hands behind head, exhale all air, crunch abs hard",
          "One leg forward with quad fully flexed, toe pointed",
          "Keep lats flared, show serratus and obliques",
        ],
        muscles: "Abdominals, obliques, serratus, quadriceps, calves",
        mistakes: [
          "Leaning too far forward — skin folds over muscle",
        ],
        proTips: [
          "THE conditioning pose — low body fat is non-negotiable here",
        ],
      },
      {
        id: "mm",
        name: "Most Muscular",
        cues: "Crab or hands-on-hips — flex everything, show full muscularity and conditioning",
        steps: [
          "Choose variant: Crab (maximum mass display) or Hands-on-Hips (conditioning focus)",
          "Crab: hinge forward, ball fists, contract traps/shoulders/chest/arms",
          "Hands-on-Hips: hands on hips, contract forward and upward, keep head up",
          "Flex EVERYTHING — this pose showcases maximum muscle simultaneously",
        ],
        muscles: "All front-facing: pecs, obliques, delts, biceps, forearms, abs, quads, calves",
        mistakes: [
          "Crunching too far forward — looks smaller",
          "Forgetting legs — must flex everything",
        ],
        proTips: [
          "Choose the variant that best highlights YOUR physique strengths",
        ],
      },
    ],
  },
];

// ─── UNIVERSAL PRO WISDOM ────────────────────────────────────
export const PRO_WISDOM = [
  { source: "Lee Labrada", quote: "The mesmerizing presentation comes from doing the transitions — don't fumble from one static pose to the next." },
  { source: "Chris Bumstead", quote: "Posing helps build a stronger mind-muscle connection by teaching your body to contract muscles with precision. It's not just about flexing — it's about learning to isolate and activate with intent." },
  { source: "Chris Bumstead", quote: "If you're serious about bodybuilding, posing deserves a permanent spot in your weekly routine. Practice after your workout or later in the day after a meal." },
  { source: "Lee Labrada", quote: "The ultimate goal is to hide imperfections on stage. Insert your most impactful poses at the high points of the music." },
  { source: "Pro Coaches", quote: "Start posing practice ideally a YEAR before competition. Posing in your bathroom is MUCH different from posing on stage under lights." },
  { source: "Pro Coaches", quote: "A 30-minute posing session should be as exhausting as a gym workout. If it's not, you're not flexing hard enough." },
  { source: "Pro Coaches", quote: "Highlight strengths, minimize weaknesses — every pose should be customized to YOUR body. Build stage presence from the inside out." },
];

export default DIVISIONS;
